import { Box, Stack, Typography } from "@mui/material";
import Image from "next/image";
import { FC } from "react";
import { GlobalErrorPageProps } from "../lib/type";

export const GlobalErrorPage: FC<GlobalErrorPageProps> = ({ title, description, image }) => {
    return (
        <section className={"flex h-screen flex-col justify-center"}>
            <Stack className={"flex flex-col items-center gap-2"}>
                {image && (
                    <Box>
                        <Image quality={100} priority {...image} />
                    </Box>
                )}
                <Typography component={"h1"} variant={"h2"}>
                    {title}
                </Typography>
                <Typography
                    component={"p"}
                    variant={"body1"}
                    className={"inline max-w-[600px] text-center"}
                >
                    {description}
                </Typography>
            </Stack>
        </section>
    );
};
